/**
 * Hier wird das Submenu eingebunden und die einzelenen Module dazu verlinkt Bei Bedarf kann auch ein Modul ausgetauscht werden oder lokal neu entwickelt werden.
 */

import React from 'react'
import { Grid } from '@mui/material'

import { Redirect, Route, Switch } from 'react-router-dom'
import { useRouteMatch } from 'react-router'
import EditorDashboardPosting from './subScreens/EditorDashboardPosting'
import EditorDashboardNetworkContent from './subScreens/EditorDashboardNetworkContent'
import UserDashboardCalendar from '../../User/UserDashboard/subScreens/UserDashboardCalendar'
import EditorDashboardDetails from './subScreens/EditorDashboardDetails'
import EditorDashboardTemplate from './subScreens/EditorDashboardTemplate'

const EditorDashboard: React.FC = () => {
  const { path } = useRouteMatch()

  return (
    <Grid container columnSpacing={2} sx={{ px: 2, pb: 12 }}>
      <Grid
        xs={12}
        item
        container
        direction='row'
      >
        <Grid container item xs={12}>
          <Switch>
            <Redirect exact from={`${path}`} to={`${path}/networkContent`}/>
            <Route exact path={`${path}/networkContent`}>
              <EditorDashboardNetworkContent/>
            </Route>
            <Route path={`${path}/networkContent/templateDetails/:id`}>
              <EditorDashboardDetails/>
            </Route>
            <Route path={`${path}/takeTemplate`}>
              <EditorDashboardTemplate/>
            </Route>
            <Route path={`${path}/posting`}>
              <EditorDashboardPosting/>
            </Route>
            <Route path={`${path}/calendar`}>
              <UserDashboardCalendar/>
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EditorDashboard
